<template>
  <div>
    <form-field-select
      label="Status"
      v-model="form.status"
      :validation-errors="validationErrors.status"
    >
      <option
        v-for="status in statuses"
        :key="status.value"
        :value="status.value"
      >{{ status.label }}</option>
    </form-field-select>

    <form-field-currency
      label="Sale Amount"
      v-model="form.sale_amount"
      :validation-errors="validationErrors.sale_amount"
    ></form-field-currency>

    <form-field-currency
      label="Total Costs"
      v-model="form.total_costs"
      :validation-errors="validationErrors.total_costs"
    ></form-field-currency>

    <form-field-date-picker
      label="Accepted At"
      v-model="form.accepted_at"
      :validation-errors="validationErrors.accepted_at"
      is-inline
      has-clear-button
    ></form-field-date-picker>

    <form-field-date-picker
      label="Contracted At"
      v-model="form.contracted_at"
      :validation-errors="validationErrors.contracted_at"
      is-inline
      has-clear-button
    ></form-field-date-picker>

    <form-field-date-picker
      label="Closing At"
      v-model="form.closing_at"
      :validation-errors="validationErrors.closing_at"
      is-inline
      has-clear-button
    ></form-field-date-picker>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {ENUMS} from "../services/enums";

  export default {
    name: "FlipSellingInfoForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          market_id: '',
          record_id: '',
          sale_amount: '',
          total_costs: '',
          status: '',
          accepted_at: '',
          contracted_at: '',
          closing_at: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      statuses() {
        return ENUMS.FixAndFlipSellingInfoStatusEnum;
      }
    },
    methods: {
      update() {
        return this.$api.fixAndFlipSellingInfos.update(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'FixAndFlipSellingInfo was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        return this.$api.fixAndFlipSellingInfos.create(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'FixAndFlipSellingInfo was created',
              type: 'is-success'
            });

            return res;
          })
        },
      delete() {
        return this.$api.fixAndFlipSellingInfos.delete(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'FixAndFlipSellingInfo was archived',
              type: 'is-success'
            });

            return res;
          });
      },
      restore() {
        return this.$api.fixAndFlipSellingInfos.restore(this.form.id)
          .then(res => {
            this.$buefy.toast.open({
              message: 'FixAndFlipSellingInfo was restored',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
